<template>
  <div class="">
    <!-- image/* :accept="accept"       :capture="false" -->
    <!-- <van-uploader
      v-model="fileList"
      accept="image/*"
      :max-count="maxCount"
      :max-size="maxSize"
      :multiple="false"
      :preview-image="false"
      @oversize="oversize"
      :after-read="afterRead"
    > 
    
      <van-button icon="photo" size="middle" class="btn_sync" type="primary">
        上传素材
      </van-button>
    </van-uploader> -->

    <input
      type="file"
      :accept="accept" 
      :multiple="true"
      @change="handleFileChange"
      ref="fileInput"
      style="display: none;"
    />
    <van-button 
      icon="photo" 
      size="middle" 
      class="btn_sync" 
      type="primary" 
      @click="openFilePicker">
      上传素材
    </van-button>


    <loading :show="isLoading" :percent="percent" color="#e7185c" />
  </div>
</template>

<script>
/**
 * 多文件上传 阿里云
 * **/
import Loading from './Loading.vue'
import OSS from 'ali-oss';
import store from '@/store';
import { Toast } from 'vant-green';
export default {
  components: { Loading },
  props: {
    // 文件列表
    value: {
      type: [String, Object, Array],
      default() {},
    },
    // 文件大小限制 单位 byte (1024byte=1kb 1024kb=1Mb)
    maxSize: {
      type: [Number, String],
      default: 1024 * 1024 * 100,
    },
    // 文件数量限制 默认只能上传一张
    maxCount: {
      type: [Number, String],
      default: 9,
    },
    // 图片选取模式，可选值为camera(直接调起摄像头)
    capture: {
      type: String,
      default: '',
    },
    // 所属id
    sortId: {
      type: String,
      default: '',
    },
    // 上传隐藏组件
    loadingHide: {
      type: Boolean,
      default: false,
    },
    // 请求携带参数 type
    params: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      ossData: {}, // 阿里云oss配置
      fileList: [],
      isLoading:false,
      percent: 0,
      allLength:0,
      progress:0
    };
  },

  watch:{

  },

  computed: {
    // 组件使用允许上传的文件类型
    accept() {
      const accept = {
        // audio: 'audio/mp3,audio/mpeg',
        // video: 'video/mp4',
        // img: 'image/png, image/jpeg, image/jpg',
        audio: 'audio/*',
        video: 'video/*',
        img: 'image/*',
      };
      return accept[this.fileType];
    },
    // 文件类型
    fileType() {
      return this.getFileType(this.params.type);
    },
  },
  created() {
    this.init();
  },

  methods: {
    // 初始化
    init() {
      if (!this.$store.state.user.userId) {
        store.dispatch('user/getInfo').then((res) => {});
      }
      store.dispatch('user/getAli').then((res) => {
        this.ossData = res;
      });
    },
    //  文件大小限制
    oversize() {
      Toast('文件大小应小于' + this.maxSize / 1024 + 'kb');
    },

    // 文件类型
    getFileType(number) {
      const fileType = {
        1: 'img', // 图片
        2: 'video', // 完整视频
        3: 'audio', // 素材视频
        4: 'audio', // 配音
        5: 'audio', // BGM
      };
      return fileType[number];
    },

    // 获取文件后触发上传  vant版本 ios无法打开相册
    afterRead(files, detail) {
      this.isLoading = true;
      // console.log('获取文件后触发上传');
      // console.log(files);
      this.progress = 0;
      this.allLength = files.length;
      files.forEach(file =>
        this.uploadFile(file.file)
      );
    },

    // 定义上传方法。
    async uploadFile(file) {
      const client = new OSS(this.ossData.base);
      const that = this;
      // console.log('开始上传');
      // console.log(file);
      // console.log('that.$store.state.user.userId');
      // console.log(that.$store.state.user.userId);
      // console.log('that.fileType');
      // console.log(that.fileType);
      // console.log('that.sortId');
      // console.log(that.sortId);
      try {
        // 填写Object完整路径。Object完整路径中不能包含Bucket名称。
        // 您可以通过自定义文件名（例如exampleobject.txt）
        // 或目录（例如exampledir/exampleobject.txt）的形式，
        // 实现将文件上传到当前Bucket或Bucket中的指定目录。
        const { res, data } = await client.multipartUpload(
          `${that.$store.state.user.userId}/${that.fileType}/${that.parseTime(new Date(), '{y}-{m}-{d}')}/${that.getRandomName(file.name)}`,
          file,
          { 
            progress(p, checkpoint) {
              that.percent = p * 100;
              // console.log("上传进度");
              // console.log(p);
              // console.log(checkpoint);
              // onProgress({ percent: p * 100 })
              // checkpoint参数用于记录上传进度，断点续传上传时将记录的checkpoint参数传入即可。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
              // tempCheckpoint = checkpoint
            },
            parallel: 4,
            // 设置分片大小。默认值为1 MB，最小值为100 KB。
            partSize: 1024 * 1024,
            meta: { year: 2025, people: 'test' },
            mime: file.type,
            callback: {
              url: that.ossData.callback.callbackUrl,
              body: that.ossData.callback.callbackBody,
              contentType: that.ossData.callback.callbackBodyType,
              customValue: {
                filename: file.name,
                type: String(that.params.type),
                category: that.sortId,
                suffix: that.getSuffix(file.name),
              },
            },
          }
        );

        if (res.status === 200 && data.code === 0) {
          console.log('文件上传成功');
          this.progress += 1;
          this.endClose()
          // console.log(data);
          // console.log(file);
          // console.log(that.fileList);
          // this.$emit('UploadSuccessful')
        } else {
          this.progress += 1;
          console.log('文件上传失败，服务器端无响应');
          // console.log(data);
          // console.log(file);
          // console.log(that.fileList);
          this.isLoading = false;
          // this.$emit('UploadErr')
          this.endClose()
        }
      } catch (e) {
        this.progress += 1;
        console.log('文件上传失败，请求封装失败');
        // console.log(e);
        // console.log(file);
        // console.log(that.fileList);
        this.isLoading = false;
        // this.$emit('UploadErr')
        this.endClose()
      }
    },

    // 格式化时间
    parseTime(time, cFormat) {
      if (arguments.length === 0 || !time) {
        return null;
      }
      const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
      let date;
      if (typeof time === 'object') {
        date = time;
      } else {
        // 兼容苹果手机
        if (
          typeof time === 'string' &&
          /^(\d{4})-(\d{2})-(\d{2}) (([0-2][0-3])|([0-1][0-9])):[0-5][0-9]:[0-5][0-9]$/.test(
            time
          )
        ) {
          time = time.replace(/-/g, '/');
        } else if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
          time = parseInt(time);
        } else if (typeof time === 'number' && time.toString().length === 10) {
          time = time * 1000;
        }
        date = new Date(time);
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
      };
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
          return ['日', '一', '二', '三', '四', '五', '六'][value];
        }
        if (result.length > 0 && value < 10) {
          value = '0' + value;
        }
        return value || 0;
      });
      return time_str;
    },

    // 获取任意长度的随机数字字母组合字符串 @param {*} len 随机字符串的长度
    getRandomString(length) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },

    // 获取随机名称
    getRandomName(name) {
      return this.getRandomString(20) + this.getSuffix(name);
    },

    // 获取文件后缀
    getSuffix(name) {
      const arr = name.split('.');
      return '.' + arr[arr.length - 1];
    },

    // 上传结束
    endClose(){
      // console.log('上传结束');
      // console.log(this.allLength);
      // console.log(this.progress);
      if(this.allLength === this.progress){
        // console.log('结束进入');
        this.$emit('UploadSuccessful')
        this.isLoading = false;
      }
    },

    // 打开文件选择器
    openFilePicker() {
      this.$refs.fileInput.click();
    },
    // 处理文件选择
    handleFileChange(event) {
      const files = event.target.files;
      this.isLoading = true;
      this.progress = 0;
      this.allLength = files.length;
      Array.from(files).forEach(file => this.uploadFile(file));
    }
  },
};
</script>

<style lang="scss" scoped>
.btn_sync {
  width: 180px;
}
</style>
